export default "__VITE_ASSET__B9blr9XY__"